import React, { useEffect } from "react";
import { Controller, Control, FieldErrors, UseFormSetValue } from "react-hook-form";
import { Form } from "react-bootstrap";

interface DateBaseComponentProps {
    control: Control<any>;
    errors: FieldErrors<{
        filter: {
            property_id: string;
            start_date: string;
            end_date: string;
            date_base?: string;
            room_type_id?: string;
        };
    }>;
    setValue: UseFormSetValue<any>;
}

const DateBaseComponent: React.FC<DateBaseComponentProps> = ({ control, errors, setValue }) => {
    // Set default value saat pertama kali data tersedia
    useEffect(() => {
        setValue("filter.date_base", "extra_date", { shouldValidate: true });
    }, [setValue]);

    return (
        <div>
            <Form.Label className="me-2">Based On:</Form.Label>

            <Controller
                name="filter.date_base"
                control={control}
                render={({ field }) => (
                    <div>
                        <Form.Check
                            type="radio"
                            id="date-base-extra"
                            label="Extra Date"
                            value="extra_date"
                            checked={field.value === "extra_date"}
                            onChange={() => field.onChange("extra_date")}
                        />
                        <Form.Check
                            type="radio"
                            id="date-base-checkin"
                            label="Check-in Date"
                            value="checkin_date"
                            checked={field.value === "checkin_date"}
                            onChange={() => field.onChange("checkin_date")}
                        />
                        {errors.filter?.date_base && (
                            <div className="text-danger mt-1">
                                {errors.filter.date_base.message as string}
                            </div>
                        )}
                    </div>
                )}
            />
        </div>
    );
};

export default DateBaseComponent;
